<dodo-info-dialog-layout class ="infoDialogWidth"
[source]="_source" (close)="closeDialog()">
	<div class="header" header>
		<div class="title">
			Find your SIM number
		</div>
	</div>
	<div class="content" content>		
		<div class="heading">
			Your SIM number is located here:
			<button type="button" class="rounded-circle close-btn" data-dismiss="modal" (click)="closeDialog()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="heading">
			<img
				src="/assets/img/find-sim-on-card-JUL23.png"
			/>
			<span>OR</span>
			<img
				src="/assets/img/find-sim-JUL23.png"
			/>
		</div>
		<div class="actions">
			<secondary-button class="action-btn" color="secondary" (clicked)="closeDialog()"
				[height]="50" 
				[theme]="buttonTheme">
				GOT IT
			</secondary-button>
			<!-- <dodo-raised-button 
			[color]="'secondary'"
			[height]="48"
			(clicked)="closeDialog()"
			> <div class="text">GOT IT </div>
			</dodo-raised-button> -->
		</div>
	</div>
</dodo-info-dialog-layout>
